import React from 'react';
import { Container, Card, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Teams = () => {
  return (
    <Container className="mt-4">
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2>Team Management</h2>
              <p className="text-muted">Organize agents into teams and manage team structures</p>
            </div>
            <Button as={Link} to="/admin" variant="outline-primary">
              ← Back to Dashboard
            </Button>
          </div>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="coming-soon-card">
            <div className="icon">
              <i className="bi bi-people-fill"></i>
            </div>
            <h3>Coming Soon</h3>
            <p className="text-muted mb-4">
              The Team Management feature is currently under development. 
              You'll be able to create teams, assign team leads, and 
              manage team-specific workflows.
            </p>
            <div className="bg-light p-3 rounded mb-3">
              <h6>Planned Features:</h6>
              <ul className="list-unstyled">
                <li>✓ Team creation and management</li>
                <li>✓ Team lead assignment</li>
                <li>✓ Team performance analytics</li>
                <li>✓ Cross-team collaboration</li>
              </ul>
            </div>
            <Button variant="primary" disabled>
              Notify Me When Ready
            </Button>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Teams;